import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Link } from "react-router-dom"

import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import { Dropdown, Modal } from "react-bootstrap"
import Select from "react-select"

import { httpOk, GET, PUT, POST } from 'helpers/api'
import { formatMoney, regexPhoneNumber } from 'helpers/helpers'

function Index({ modal, setModal, selectClient }) {
	const { t } = useTranslation()

	const [showModal, setShowModal] = useState(false)
	const [selectedItem, setSelectedItem] = useState({})

	const [filterData, setFilterData] = useState({
	})
	const [pagination, setPagination] = useState({
		url: '/report-clients',
		response: null
	})
	const [data, setData] = useState([])
	const [clientTypes, setClientTypes] = useState([])

	async function createUpdate(e) {
		e.preventDefault();

		var response;
		console.log(selectedItem);
		var selectedItemCopy = { ...selectedItem }
		selectedItemCopy.id = selectedItemCopy.client_id;
		if (selectedItemCopy.id) {
			response = await PUT('/clients', selectedItemCopy, { loader: true })
		} else {
			response = await POST('/clients', selectedItemCopy, { loader: true })
		}

		if (httpOk(response)) {
			searchWithFilter()
			toggleModal(false)
		}
	}

	function handleInputChange(e) {
		var selectedItemCopy = { ...selectedItem }
		selectedItemCopy[e.target.name] = e.target.value
		setSelectedItem(selectedItemCopy)
	}

	async function toggleModal(bool, item = { 'gender': 1 }) {
		if (bool) {
			setSelectedItem({ ...item })
		}
		setShowModal(bool)
		// if (modal) setModal(!bool);
	}

	async function searchWithFilter() {

		const response = await GET(`/report-clients`, filterData, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': `/report-clients`, 'response': response.data })
		}
	}

	async function paginate(page, size) {
		setFilterData({ ...filterData, 'page': page, 'size': size })
	}

	async function getClientTypes() {
		const response = await GET('/helper/clients-types')
		if (httpOk(response)) setClientTypes(response.data)
	}

	useEffect(() => {
		getClientTypes()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		searchWithFilter(false)
	}, [filterData.search, filterData.page, filterData.client_type, filterData.size]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className={`page-header ${modal ? 'modal-page' : ''}`}>
				<h4 className="vertical-center h-100">
					{t('clients')} [{pagination?.response?.total}]
				</h4>
			</div>

			<div className={`card ${modal ? 'modal-page' : ''}`}>
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex gap-2">
							<div>
								<FilterSearch
									filterData={filterData}
									setFilterData={setFilterData}>
								</FilterSearch>
							</div>
							<div style={{ width: '250px' }}>
								<div className="form-group">
									<Select
										options={clientTypes}
										value={clientTypes.find(option => option.id === filterData?.client_type) || ''}
										onChange={(option) => setFilterData({ ...filterData, client_type: option?.id })}
										placeholder={t('client_types')}
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
										isClearable
									/>
								</div>
							</div>
						</div>
						<div>
							<div className="d-between gap-2">
								<h5><b>{t('sale_amount')}</b>:</h5>
								<h5 className="text-end">
									<span className={`text-success`}>
										{formatMoney(data.total_amount)}
									</span>
								</h5>
							</div>
							<div className="d-between gap-2">
								<h5><b>{t('amount_of_debt')}</b>:</h5>
								<h5 className="text-end">
									<span className={`${data.total_debt_amount > 0 ? 'text-success' : 'text-danger'}`}>
										{formatMoney(data.total_debt_amount)}
									</span>
								</h5>
							</div>
						</div>
					</div>

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '30%' }}>{t('client')}</th>
									<th style={{ 'width': '15%' }}>{t("phone")}</th>
									<th style={{ 'width': '15%' }}>{t("type")}</th>
									<th style={{ 'width': '20%' }} className="text-end">{t("sale_amount")}</th>
									<th style={{ 'width': '20%' }} className="text-end">{t("amount_of_debt")}</th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr className="tr-middle" key={index}>
										<td className="text-center">{item.row_number}</td>
										<td className="td-ellipsis">
											{modal ?
												<div className="text-primary cursor" onClick={() => selectClient(item)}>
													{item.name}
												</div>
												:
												<Link className="text-primary cursor table-first-column-clickable"
													to={`/report-clients-debts/${item.client_id}`}>
													{item.name}
												</Link>
											}
										</td>
										<td className="text-nowrap">{regexPhoneNumber(item.phone)}</td>
										<td className="text-nowrap">{item.client_type_name}</td>
										<td className="text-end text-nowrap">
											<div className={item.cheque_balance >= 0 ? 'text-success' : 'text-danger'}>
												<span>{formatMoney(item.cheque_balance)}</span>
											</div>
										</td>
										<td className="text-end text-nowrap">
											<div className={item.balance >= 0 ? 'text-success' : 'text-danger'}>
												<span>{formatMoney(item.balance)}</span>
											</div>
										</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModal(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</div>
			</div>

			{/* MODAL */}
			<Modal show={showModal} animation={false} centered backdrop="static"
				dialogClassName="update-modal-width" onHide={() => toggleModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{selectedItem.client_id ?
							<>{t('edit')}</>
							:
							<>{t('create')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => createUpdate(e)} autoComplete="off">
						<div className="form-group">
							<label>{t('name')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="name"
								value={selectedItem.name ?? ''}
								onChange={(e) => handleInputChange(e)} />
						</div>
						<div className="form-group">
							<label>{t('phone')}</label>
							<input type="number" className="form-control" name="phone"
								value={selectedItem.phone ?? ''}
								onChange={(e) => handleInputChange(e)} />
						</div>
						<div className="form-group">
							<label>{t('phone')} (2)</label>
							<input type="number" className="form-control" name="phone2"
								value={selectedItem.phone2 ?? ''}
								onChange={(e) => handleInputChange(e)} />
						</div>
						<div className="form-group">
							<label>{t('client_types')}</label>
							<Select
								isClearable
								options={clientTypes}
								value={clientTypes.find(option => option.id === selectedItem.client_type_id) || ''}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'client_type_id': option.id })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>

						<div className="form-group">
							<label>{t('note')}</label>
							<input type="text" className="form-control" name="note"
								value={selectedItem.note ?? ''}
								onChange={(e) => handleInputChange(e)} />
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL */}
		</>
	)
}

export default Index
